import clsx from "clsx";
import { forwardRef, useState } from "react";

import { SearchIcon } from "../Icon";
import { SEARCH_CLASS_NAME } from "./const";
import { useSearchboxBlur } from "./hooks";
import { SearchFloatOptions } from "./SearchFloatOptions";
import { SearchboxProps } from "./type";

export const Searchbox = forwardRef<HTMLInputElement, SearchboxProps>(
  ({ transparent, options, onSelectOption, floatAreaFooter, isLoading = false, block = false, ...props }, ref) => {
    const [focused, setFocused] = useState(false);
    const { noCloseRef } = useSearchboxBlur(() => setFocused(false));

    return (
      <div className={clsx("relative m-auto", block ? "w-full" : "max-w-[460px]")} ref={noCloseRef}>
        <div className={SEARCH_CLASS_NAME({ transparent: !!transparent })}>
          <input
            ref={ref}
            type="text"
            className="text-ui16 grow bg-[transparent] focus:outline-none"
            onFocus={() => setFocused(true)}
            {...props}
          />
          <SearchIcon />
        </div>
        <SearchFloatOptions
          isOpen={focused && !!props.value}
          isLoading={isLoading}
          options={options}
          onSelectOption={(patient) => {
            onSelectOption?.(patient);
            setFocused(false);
          }}
          floatAreaFooter={floatAreaFooter}
        />
      </div>
    );
  },
);

Searchbox.displayName = "Searchbox";
